export default function AdmissionNote({ note, onChange }) {
  const update = (field, value) => onChange({ ...note, [field]: value });
  const updatePatient = (field, value) =>
    onChange({ ...note, patient: { ...note.patient, [field]: value } });

  const fields = [
    { key: 'chief_complaint', label: 'Chief Complaint' },
    { key: 'hpi', label: 'History of Present Illness' },
    { key: 'surgical_history', label: 'Surgical History' },
    { key: 'family_history', label: 'Family History' },
    { key: 'social_history', label: 'Social History' },
    { key: 'review_of_systems', label: 'Review of Systems' },
  ];

  return (
    <div className="space-y-4">
      <div className="card-surface p-4">
        <h4 className="text-section-label mb-3">Patient header</h4>
        <div className="grid grid-cols-2 gap-3">
          {['name', 'room', 'age', 'sex', 'nationality'].map((f) => (
            <input
              key={f}
              type="text"
              placeholder={f.charAt(0).toUpperCase() + f.slice(1)}
              value={note.patient?.[f] || ''}
              onChange={(e) => updatePatient(f, e.target.value)}
              className="rounded-lg border border-gray-200 px-3 py-2 text-sm"
            />
          ))}
        </div>
      </div>
      {fields.map(({ key, label }) => (
        <div key={key} className="card-surface p-4">
          <label className="text-section-label mb-2 block">{label}</label>
          <textarea
            value={note[key] || ''}
            onChange={(e) => update(key, e.target.value)}
            rows={3}
            className="w-full rounded-lg border border-gray-200 px-3 py-2 text-sm"
          />
        </div>
      ))}
      <div className="card-surface border-l-4 border-critical p-4">
        <label className="text-section-label mb-2 block">Allergies</label>
        <textarea
          value={(note.allergies || []).join('\n')}
          onChange={(e) => update('allergies', e.target.value.split('\n').filter(Boolean))}
          rows={2}
          placeholder="One per line"
          className="w-full rounded-lg border border-gray-200 px-3 py-2 text-sm"
        />
      </div>
    </div>
  );
}
